import { advancedFlowSchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { z } from "zod";

export const getAdvancedFlowById = {
  input: z.object({ flowId: z.string() }),
  output: z.object({ advancedFlow: advancedFlowSchema }),
};
